const PLAY_ICON_LARGE_SIZE = 14;
const PLAY_ICON_MEDIUM_SIZE = 12;
const PLAY_ICON_SMALL_SIZE = 10;

export const calcIconSize = ({ isLG, isMobile, isMD }) => {
    switch (true) {
        case isLG && !isMobile:
            return PLAY_ICON_LARGE_SIZE;
        case isMD:
            return PLAY_ICON_MEDIUM_SIZE;
        default:
            return PLAY_ICON_SMALL_SIZE;
    }
};
